<template>
  <div class="projects">
      <project-list :latest="false"/>
  </div>
</template>

<script>
import ProjectList from '../components/ProjectList.vue';

export default {
  name: 'projects',
  components: {
    ProjectList,
  },
};
</script>
